var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.2 20",
    width: 14.2,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.9,15.9h-1.4c-.2,0-.4-.2-.4-.4s.2-.4.4-.4h1V.7H2.4c-.2,0-.4-.2-.4-.4s.2-.4.4-.4h11.5c.2,0,.4.2.4.4v15.2c0,.2-.2.4-.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.3,20s0,0-.1,0c-.1,0-.2-.2-.2-.3v-2c0-.2.2-.4.4-.4s.4.2.4.4v1.2l.3-.3c.1-.1.4-.1.5,0l.3.3v-1.2c0-.2.2-.4.4-.4s.4.2.4.4v2c0,.1,0,.3-.2.3-.1,0-.3,0-.4,0l-.7-.7-.7.7c0,0-.2.1-.3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.4,17.2c-.2,0-.3-.2-.3-.3V1.6c0-.2.2-.3.3-.3s.3.2.3.3v15.2c0,.2-.2.3-.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.8,16.7c-.2,0-.3-.2-.3-.3h0c0-.3.2-.5.3-.5s.3.2.3.3h0c0,.3-.2.5-.3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.8,16.6s0,0-.1,0c-.1,0-.2-.2-.2-.3V2.8H1.2c-.7,0-1.2-.5-1.2-1.2C0,.7,1,0,2.4,0s.4.2.4.4v.7h10.1c.2,0,.4.2.4.4v13.8c0,0,0,.2-.1.3l-1.1,1.1c0,0-.2.1-.3.1ZM2.1.7c-.8,0-1.3.4-1.3.9s.2.5.5.5h10.6c.2,0,.4.2.4.4v12.9l.3-.3V1.8H2.4c-.2,0-.4-.2-.4-.4v-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.8,18H1.2C.5,18,0,17.5,0,16.8s.2-.4.4-.4.4.2.4.4.2.5.5.5h10.2v-.9c0-.2.2-.4.4-.4s.4.2.4.4v1.3c0,.2-.2.4-.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2,2.8c-.3,0-.5,0-.7-.2-.2-.1-.3-.3-.3-.6,0-.5.6-1,1.5-1s.3.2.3.3-.2.3-.3.3c-.6,0-.8.2-.8.3,0,0,.1,0,.4,0,.2,0,.3.2.3.3s-.2.3-.3.3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBook);
export default __webpack_public_path__ + "static/media/icon-book.5953c032073d972b4add82275d6efc8a.svg";
export { ForwardRef as ReactComponent };